import { http } from '@/core/helpers/http.helper';
import { ApiResource } from '@/core/models/api-resource.interface';
import { Module } from '../../modules/module.interface';
import { Role } from '../../modules/roles/role.interface';

export class RoleService {
   async getRoles(userId: number) {
      const response = await http.get<ApiResource<Role>>(`/users/${userId}/roles`);
      return response.data;
   }

   async postRolesBatch(userId: number, roles: Array<Role>) {
      const response = await http.post<Array<Module>>(`/users/${userId}/roles-batch`, { roles });
      return response.data;
   }

   async deleteRolesBatch(userId: number, roles: Array<Role>) {
      const response = await http.delete<Array<Module>>(`/users/${userId}/roles-batch`, { data: { roles } });
      return response.data;
   }

   async getRole() {
      throw Error('Method not implemented');
   }

   async postRole() {
      throw Error('Method not implemented');
   }

   async putRole() {
      throw Error('Method not implemented');
   }

   async deleteRole() {
      throw Error('Method not implemented');
   }
}
